<template>
  <div>
    <a :href="item.Url" class="event-card">
      <div class="event-card__picture-wrap">
        <div class="event-card__date-block">
          <template> 
            <div class="event-card__info-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" :viewBox="FrequencyLabel.viewBox">
                    <use :href="FrequencyLabel.url"></use>
                </svg>
            </div>
          </template>
          <p v-if="item.FrequencyLabel" class="event-card__frequency">{{ item.FrequencyLabel }}</p>
          <p v-else-if="item.GroupEvent" class="event-card__frequency">{{ item.GroupEvent }}</p>
          <template v-if="item.EventDatesList[0]">
            <p v-if="item.EventDatesList[0].Day" class="event-card__date">{{ item.EventDatesList[0].Day }}</p>
            <p v-if="item.EventDatesList[0].Month" class="event-card__month">{{ item.EventDatesList[0].Month }}</p>
          </template>
        </div>
        <picture class="event-card__image c-image-frame c-image-frame--border-radius-at-medium" v-if="item.Image">
          <img width="1200" height="750" class="c-image-frame__image lazyload" data-sizes="auto" alt="" :data-srcset="item.Image.Crops['16:10 Aspect Ratio Crop'].SrcSet" :data-src="item.Image.Crops['16:10 Aspect Ratio Crop'].Src">
        </picture>
      </div>
      <div class="event-card__summary">
        <div class="event-card__info">
          <template v-if="item.InPersonOnline !== ''">
            <div v-if="InPersonOnline !== null" class="event-card__info-icon">
                <svg xmlns="http://www.w3.org/2000/svg" :width="InPersonOnline.width" :height="InPersonOnline.height" :viewBox="InPersonOnline.viewBox">
                    <use :href="InPersonOnline.url"></use>
                </svg>
            </div>
            <span class="event-card__info-item">{{ item.InPersonOnline }}</span>
          </template>
          <template v-if="item.GroupEvent !== ''">
            <div v-if="groupOrEventIcon !== null" class="event-card__info-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="23" :viewBox="groupOrEventIcon.viewBox">
                    <use :href="groupOrEventIcon.url"></use>
                </svg>
            </div>
            <span class="event-card__info-item">{{ item.GroupEvent }}</span>
          </template>
        </div>
        <h2 class="event-card__heading">
          {{ item.Name }}
        </h2>
        <p class="event-card__address">{{ item.Address }}</p>
        <p class="event-card__time">{{ item.Time }}</p>
        <ul class="mini-tag-list">
          <template v-if="item.Tags">
            <li class="mini-tag-list__item" v-for="tag in item.Tags.slice(0, 2)" :key="tag">{{ tag.Name }}</li>
            <li v-if="item.Tags.length > 2" class="mini-tag-list__item">...</li>
          </template>
          <li v-else-if="item.PrimaryTag" class="mini-tag-list__item">{{ item.PrimaryTag.Name }}</li>
        </ul>
      </div>
    </a>
  </div>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        defaultSelectedTags: {
            type: Array,
            default: () => []
        },
        hideTags: {
            type: String,
            required: false,
            default: ''
        }
    },
    computed: {
        intersectedTags() {
            if(this.defaultSelectedTags && this.defaultSelectedTags.length && this.item.Tags.length) {
                const tagList = this.item.Tags.map(x => x.Name)
                const intersection = this.defaultSelectedTags.filter(element => tagList.includes(element))
                return intersection
            }
            return ''
        },
        groupOrEventIcon() {
          const icon = {}
          if(this.item.GroupEvent == 'Group') {
            icon.url = '/dist/images/icons.svg#icon-people'
            icon.viewBox = '0 0 22.304 14.549'
          } else {
            icon.url = '/dist/images/icons.svg#icon-calendar'
            icon.viewBox = '0 0 95 93.2'
          }
          return icon
        },
        InPersonOnline() {
          const icon = {}
          if(this.item.InPersonOnline == 'Online') {
            icon.url = '/dist/images/icons.svg#icon-online-screen'
            icon.viewBox = '0 0 13 11.4'
            icon.height = '17'
            icon.width = '22'
          } else {
            icon.url = '/dist/images/icons.svg#icon-person'
            icon.viewBox = '0 0 12 16'
            icon.height = '16.036'
            icon.width = '12.701'
          }
          return icon
        },
        FrequencyLabel() {
          const icon = {}
          if(this.item.FrequencyLabel !== '') {
            icon.url = '/dist/images/icons.svg#icon-event-recurring'
            icon.viewBox = '0 0 14.1 16.3'
          } else {
            icon.url = '/dist/images/icons.svg#icon-calendar'
            icon.viewBox = '0 0 12 16'
          }
          return icon
        }
    }
}
</script>
